module.exports = __webpack_public_path__ + "static/carien-1-47597a76cde9aaf34d9917765faafcb9.jpg";